<script lang="ts">
  export let icon: string
  export let title: string
  export let content: string
</script>

<div class="w-[400px] flex flex-row align-start gap-6">
    <img src={icon} alt={title} class= 'h-24 w-24 text-cs-orange' />
  <div class="my-0 text-left leading-6 ">
    <h2>{title}</h2>
    <p class=" text-black leading-7">{content}</p>
  </div>
</div>
